import LoginImg from "./login-design.png";
import ForgotImg from "./forgot-design.png";
import HomeImg from "./home-img.png";
import HomeImg2 from "./home-img2.png";
import HomeImg3 from "./home-img3.png";
import WP1 from "./workingProject1.png";
import SampleProjectImg from "./sample-project-img.png";
import SampleProjectImg2 from "./sample-project-img-2.png";
import Logo from "./Logo.png";
import DefaultAvatar from "./default-avatar.png";
import ResetPasswordImg from "./forgot-password-img.png";

const Images = {
  LoginImg,
  ForgotImg,
  ResetPasswordImg,
  HomeImg,
  HomeImg2,
  HomeImg3,
  Logo,
  WP1,
  SampleProjectImg,
  SampleProjectImg2,
  DefaultAvatar,
};

export { Images };
